import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { sablonOnizlemeGetir, dosyaUrl } from '../services/api';
import { temaGetir } from '../temalar';
import { paraFormatla } from '../paraFormat';

// Admin panelindeki Şablonlar > Önizle butonu için — artık şablonlar bağımsız SABLON* tablolarında
// yaşadığı için gerçek bir işletme/slug üzerinden değil, doğrudan şablon id'si üzerinden önizleniyor.
// Tasarımı gösterir ama sipariş/garson çağırma gibi hiçbir gerçek işlem tetiklemez — tüm butonlar
// görsel olarak durur ama işlevsizdir. Kullanıcı talebi: 2026-07-26 / 2026-07-27 (bağımsız tablolara taşıma).
export default function SablonOnizleme() {
  const { id } = useParams();
  const [sablon, setSablon] = useState(null);
  const [hata, setHata] = useState('');
  const [aktifGrup, setAktifGrup] = useState(null);

  useEffect(() => {
    sablonOnizlemeGetir(id)
      .then((res) => {
        setSablon(res.data);
        if (res.data.gruplar.length > 0) setAktifGrup(res.data.gruplar[0].id);
      })
      .catch((err) => setHata(err.response?.data?.hata || 'Şablon bulunamadı.'));
  }, [id]);

  if (hata) return <div style={{ padding: 30, textAlign: 'center', color: '#8b1a1a' }}>{hata}</div>;
  if (!sablon) return <div style={{ padding: 30, textAlign: 'center' }}>Yükleniyor...</div>;

  const tema = temaGetir(sablon.tema);

  return (
    <div style={{
      minHeight: '100vh',
      background: `radial-gradient(circle at top, ${tema.bgUst} 0%, ${tema.koyu} 55%, ${tema.bgAlt} 100%)`,
      display: 'flex', justifyContent: 'center'
    }}>
      <div style={{
        maxWidth: 480, width: '100%', minHeight: '100vh', position: 'relative',
        background: `radial-gradient(circle at 1px 1px, rgba(0,0,0,0.05) 1px, transparent 0) 0 0/24px 24px, ${tema.kartUst}`,
        boxShadow: '0 0 40px rgba(0,0,0,0.35)'
      }}>
        <div style={{
          position: 'absolute', top: 10, left: 10, right: 10, zIndex: 20, textAlign: 'center',
          background: '#fff3cd', color: '#8b5a1a', fontSize: 11, fontWeight: 700, padding: '4px 10px', borderRadius: 8
        }}>
          ÖNİZLEME — tasarım amaçlıdır, butonlar işlevsel değildir
        </div>

        <div style={{ position: 'relative', height: sablon.bannerUrl ? 'auto' : 190, background: sablon.bannerUrl ? 'transparent' : `linear-gradient(135deg, ${tema.koyu}, ${tema.bgUst})` }}>
          {sablon.bannerUrl && <img src={dosyaUrl(sablon.bannerUrl)} alt={sablon.ad} style={{ display: 'block', width: '100%', height: 'auto' }} />}
          <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to bottom, rgba(0,0,0,0.25) 0%, rgba(0,0,0,0.05) 50%, rgba(0,0,0,0.15) 100%)' }} />
        </div>

        <div style={{ textAlign: 'center', padding: sablon.logoUrl ? '0 16px 14px' : '16px 16px 14px' }}>
          {sablon.logoUrl && (
            <img
              src={dosyaUrl(sablon.logoUrl)}
              alt={sablon.ad}
              style={{
                width: 76, height: 76, borderRadius: '50%', objectFit: 'cover',
                border: `4px solid ${tema.kartUst}`, boxShadow: '0 2px 10px rgba(0,0,0,0.15)',
                marginTop: -38, background: '#fff', position: 'relative', zIndex: 2
              }}
            />
          )}
          <h1 style={{ margin: '8px 0 0', fontSize: 22, fontWeight: 800, color: tema.koyu }}>{sablon.ad}</h1>
          <div style={{ display: 'inline-block', marginTop: 6, padding: '3px 12px', borderRadius: 20, background: tema.koyu, color: '#fff', fontSize: 12, fontWeight: 700 }}>
            Masa 1
          </div>
        </div>

        <div style={{ display: 'flex', gap: 10, padding: '0 16px 16px' }}>
          <button disabled style={{ flex: 1, padding: '10px 8px', borderRadius: 10, border: '1px solid #e0e0e0', cursor: 'default', background: '#fff', color: tema.koyu, fontSize: 13, fontWeight: 700 }}>
            🔔 Garson Çağır
          </button>
          <button disabled style={{ flex: 1, padding: '10px 8px', borderRadius: 10, border: '1px solid #e0e0e0', cursor: 'default', background: '#fff', color: tema.koyu, fontSize: 13, fontWeight: 700 }}>
            🧾 Hesap İste
          </button>
        </div>

        {sablon.gruplar.length === 0 && (
          <div style={{ padding: 30, textAlign: 'center', color: '#6b7684' }}>Menü henüz hazırlanıyor.</div>
        )}

        {sablon.gruplar.length > 1 && (
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, padding: '0 16px 16px' }}>
            {sablon.gruplar.map((grup) => (
              <button
                key={grup.id}
                onClick={() => setAktifGrup(grup.id)}
                style={{
                  whiteSpace: 'nowrap', padding: '8px 16px', borderRadius: 20, border: 'none', cursor: 'pointer',
                  fontSize: 13, fontWeight: 700,
                  background: aktifGrup === grup.id ? tema.accent : '#fff',
                  color: aktifGrup === grup.id ? '#fff' : tema.koyu,
                  boxShadow: '0 1px 3px rgba(0,0,0,0.08)'
                }}
              >
                {grup.ad}
              </button>
            ))}
          </div>
        )}

        {sablon.gruplar.filter((grup) => grup.id === aktifGrup).map((grup) => (
          <div key={grup.id} style={{ padding: '4px 16px 20px' }}>
            <h3 style={{ color: tema.koyu, fontSize: 18, borderLeft: `4px solid ${tema.accent}`, paddingLeft: 10, margin: '10px 0 12px' }}>
              {grup.ad}
            </h3>
            {grup.urunler.map((urun) => (
              <div key={urun.id} style={{ display: 'flex', gap: 12, padding: 12, marginBottom: 10, background: '#fff', borderRadius: 12, boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
                {urun.gorselUrl ? (
                  <img src={dosyaUrl(urun.gorselUrl)} alt={urun.ad} style={{ width: 68, height: 68, borderRadius: 10, objectFit: 'cover', flexShrink: 0 }} />
                ) : (
                  <div style={{ width: 68, height: 68, borderRadius: 10, background: '#f0f0f0', flexShrink: 0 }} />
                )}
                <div style={{ flex: 1 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8, fontWeight: 700, color: tema.koyu }}>
                    <span>{urun.ad}</span>
                    <span style={{ color: tema.accent, whiteSpace: 'nowrap' }}>{paraFormatla(urun.fiyat)} ₺</span>
                  </div>
                  {urun.aciklama && <div style={{ fontSize: 13, color: '#6b7684', marginTop: 4 }}>{urun.aciklama}</div>}
                  <button disabled style={{ marginTop: 8, padding: '6px 14px', borderRadius: 6, border: 'none', cursor: 'default', background: tema.accent, color: '#fff', fontSize: 12, fontWeight: 700, opacity: 0.85 }}>
                    Sepete Ekle
                  </button>
                </div>
              </div>
            ))}
          </div>
        ))}

        <div style={{ textAlign: 'center', fontSize: 11, color: '#aab0b8', padding: '10px 0' }}>MenuPaylas ile hazırlanmıştır</div>
      </div>
    </div>
  );
}
